import { useState } from "react";
import { X } from "lucide-react";
import Reveal from "@/components/Reveal";
import { GALLERY as G } from "@/lib/data";
const GALLERY = ["/brand-images/founder.jpg","/brand-images/combo.jpg","/brand-images/window.jpg","/brand-images/new-nachos.jpg","/brand-images/new-tacos.jpg","/brand-images/new-chips.jpg","/brand-images/new-favs.jpg","/brand-images/merch.jpg",...G];

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <div data-testid="gallery-page" className="bg-[#121212]">
      <section className="pt-20 md:pt-28 pb-12">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C99C3A] mb-5">Gallery</p>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.98] text-[#F5ECD7]">
            The{" "}
            <span className="font-serif-italic font-normal text-[#C99C3A]">truck</span>
            , the food,
            <br />
            the people.
          </h1>
        </div>
      </section>

      <section className="pb-24 px-3 md:px-6">
        <div className="columns-2 md:columns-3 lg:columns-4 gap-3 md:gap-4">
          {GALLERY.map((src, i) => (
            <Reveal key={i} delay={(i % 6) * 60} className="break-inside-avoid mb-3 md:mb-4">
              <button
                onClick={() => setActive(src)}
                data-testid={`gallery-thumb-${i}`}
                className="block w-full overflow-hidden rounded-xl group"
              >
                <img
                  src={src}
                  alt={`Gallery ${i + 1}`}
                  loading="lazy"
                  className="w-full transition-transform duration-700 group-hover:scale-105"
                />
              </button>
            </Reveal>
          ))}
        </div>
      </section>

      {active && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[100] bg-[#0a0a0a]/95 backdrop-blur-md flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <button
            data-testid="gallery-close"
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 text-[#F5ECD7] hover:text-[#C99C3A]"
          >
            <X size={28} />
          </button>
          <img src={active} alt="" className="max-w-full max-h-[88vh] object-contain rounded-xl" />
        </div>
      )}
    </div>
  );
}
